"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.globalEnv = void 0;
// If we can't guarantee global state, don't fake it: fail instead.
let globalEnv;
exports.globalEnv = globalEnv;
// Use window (web)/self (web worker)/global (node) as appropriate
if (typeof window !== 'undefined') {
    exports.globalEnv = globalEnv = window;
}
else if (typeof self !== 'undefined') {
    exports.globalEnv = globalEnv = self;
}
else if (typeof global !== 'undefined') {
    exports.globalEnv = globalEnv = global;
}
else {
    throw new Error('Could not get global env');
}
